import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/reset.css';
import {HashRouter} from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HashRouter>
            <App />
    </HashRouter>
);
// 1. 捕获全局 JS 错误（同步+异步）
window.onerror = (message, source, lineno, colno, error) => {
    console.error('渲染进程全局错误:', message, source, lineno, colno, error);
    // 可选：通过 IPC 发送错误到主进程，写入日志
    window.electron.ipcRenderer.send('renderer-error', {
        message, source, lineno, colno, stack: error?.stack
    });
    return true; // 返回 true 表示已处理，避免浏览器默认提示
};

// 2. 捕获未处理的 Promise 错误（异步）
window.onunhandledrejection = (event) => {
    console.error('渲染进程未处理 Promise 错误:', event.reason);
    window.electron.ipcRenderer.send('renderer-rejection', {
        reason: event.reason?.message,
        stack: event.reason?.stack
    });
    event.preventDefault(); // 阻止默认行为（避免控制台警告）
};

// 3. 捕获资源加载错误（如图片、CSS、JS 加载失败）
window.addEventListener('error', (event) => {
    if (event.target instanceof HTMLScriptElement ||
        event.target instanceof HTMLLinkElement ||
        event.target instanceof HTMLImageElement) {
        console.error('资源加载错误:', event.target.src || event.target.href);
        window.electron.ipcRenderer.send('resource-error', {
            url: event.target.src || event.target.href,
            tag: event.target.tagName
        });
    }
}, true); // 第三个参数设为 true，捕获捕获阶段的错误

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
